export default __webpack_public_path__ + "38f3ea69305b1627251a8ecdf37f83c1.svg";